import React, { Component } from "react";
import { List, Icon, Checkbox, Button } from "semantic-ui-react";

const styles = {
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  iconAndName: {
    display: "flex",
    alignItems: "center"
  },
  nameAndInfo: {
    display: "flex",
    flexDirection: "column"
  },
  info: {
    color: "rgba(0,0,0,.4)"
  }
};

class EntityItem extends Component {
  state = {
    checked: false
  };
  componentDidMount() {
    this.setState({
      checked: this.props.entity.activo === 1 ? true : false
    });
  }

  render() {
    return (
      <List.Item className="listItemPadding">
        <List.Content verticalAlign="middle">
          <div style={styles.listItem}>
            <div style={styles.iconAndName}>
              <Icon size="big" color="teal" name="hospital" />
              <div style={styles.nameAndInfo}>
                <a
                  onClick={() => {
                    this.props.selectedEntity(this.props.entity);
                    this.props.showEditEntityForm();
                  }}
                >
                  {this.props.entity.nombre}
                </a>
                <span style={styles.info}>ID: {this.props.entity.nit}</span>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <Checkbox
                className="alignEnable"
                toggle
                name={this.props.entity.nombre}
                onChange={this.props.onChangeEntityCheckbox}
                checked={this.props.entity.activo === 1 ? true : false}
                floated="right"
              />
              <Button
                className="alignDelete"
                icon="trash"
                color="red"
                onClick={() => {
                  this.props.deleteEntity(this.props.entity.id);
                }}
              ></Button>
            </div>
          </div>
        </List.Content>
      </List.Item>
    );
  }
}

export default EntityItem;
